// dropzoneModule.js

function destroyExistingDropzone(elementId) {
  try {
    // Remove 'form#' from elementId for querySelector
    const cleanId = elementId.replace('form#', '#');
    const element = document.querySelector(cleanId);
    
    if (!element) {
      console.log(`Element ${elementId} not found, skipping destroy`);
      return;
    }
    
    if (element.dropzone) {
      console.log(`Destroying existing dropzone for ${elementId}`);
      element.dropzone.destroy();
    }
  } catch (e) {
    console.log(`Error destroying dropzone for ${elementId}:`, e);
  }
}

function initializeDropzone(elementId, options = {}) {
  // Remove 'form#' from elementId for querySelector
  const cleanId = elementId.replace('form#', '#');
  const element = document.querySelector(cleanId);
  
  if (!element) {
    console.log(`Element ${elementId} not found, skipping initialization`);
    return null;
  }

  destroyExistingDropzone(elementId);
  
  const defaultConfig = {
    url: options.url || '/photos',
    uploadMultiple: options.uploadMultiple || false,
    addRemoveLinks: options.addRemoveLinks !== undefined ? options.addRemoveLinks : true,
    maxFiles: options.maxFiles || 12,
    acceptedFiles: options.acceptedFiles || 'image/*',
    dictInvalidFileType: options.dictInvalidFileType || 'This form only accepts images.',
    paramName: options.paramName || "photo[thumbnail]",
    dictRemoveFile: 'Delete',
    previewsContainer: options.previewsContainer,
    init: function() {
      // Progress handling for thumbnail uploads
      if (elementId.includes('thumbnailDropzone')) {
        this.on("sending", function() {
          document.getElementById("thumbnailProgress").style.display = "block";
        });
        this.on("uploadprogress", function(file, progress) {
          document.getElementById("thumbnailProgress").querySelector(".progress-bar").style.width = progress + "%";
        });
        this.on("success", function(file, response) {
          location.reload();
        });
        this.on("error", function(file, message) {
          alert("Error uploading image: " + message);
        });
      }

      // Video thumbnail handling
      if (options.handleVideo) {
        this.on("addedfile", function(file) {
          if (file.type.match('video.*')) {
            var video = document.createElement('video');
            var reader = new FileReader();

            reader.onload = function(e) {
              video.src = e.target.result;
              video.currentTime = 1;

              video.addEventListener('loadeddata', function() {
                var canvas = document.createElement('canvas');
                canvas.width = video.videoWidth / 4;
                canvas.height = video.videoHeight / 4;

                var ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                file.previewElement.querySelector("img").src = canvas.toDataURL();
              });
            };

            reader.readAsDataURL(file);
          }
        });
      }

      this.on("success", function(file, response) {
        console.log("File uploaded successfully", response);
        if (window.util && window.util.photos) {
          window.util.photos.addToBySelector('.photos-index', response);
        }
      });
      
      this.on("error", function(file, errorMessage) {
        console.error("Error uploading file", errorMessage);
      });

      this.on("removedfile", function(file) {
        console.log(file);
      });

      if (options.additionalInit) {
        options.additionalInit.call(this);
      }
    }
  };

  try {
    // Create new Dropzone instance with merged config
    const dropzoneInstance = new Dropzone(element, { ...defaultConfig, ...options });
    console.log(`Dropzone initialized for ${elementId}`);
    return dropzoneInstance;
  } catch (e) {
    console.error(`Error initializing dropzone for ${elementId}:`, e);
    return null;
  }
}

function initDropzones() {
  // Ensure Dropzone auto-discover is disabled
  if (typeof Dropzone !== 'undefined') {
    Dropzone.autoDiscover = false;
  }
  
  // Initial dropzone with 100ms delay
  setTimeout(() => {
    const dropzoneElement = document.getElementById('dropzone');
    if (dropzoneElement) {
      initializeDropzone('#dropzone', {
        url: '/photos',
        uploadMultiple: false,
        addRemoveLinks: true,
        maxFiles: 12,
        acceptedFiles: 'image/*',
        paramName: "photo[thumbnail]",
        dictInvalidFileType: 'This form only accepts images.'
      });
    }

   
  }, 100);

  // Album and Project dropzones with 300ms delay
  setTimeout(() => {
    const albumElement = document.getElementById('dropzone_album');
    if (albumElement) {
      console.log("Initializing album dropzone");
      initializeDropzone('form#dropzone_album', {
        url: '/photos',
        uploadMultiple: false,
        addRemoveLinks: true,
        maxFiles: 12,
        acceptedFiles: 'image/*',
        paramName: "photo[file]",
        dictInvalidFileType: 'This form only accepts images.',
        additionalInit: function() {
          this.on('sending', function(file, xhr, formData) {
            var albumInput = document.querySelector('form#dropzone_album input[name="photo[album_id]"]');
            if (albumInput && albumInput.value) {
              formData.append('photo[album_id]', albumInput.value);
            }
          });
        }
      });
    }

    const projectElement = document.getElementById('dropzone_project');
    if (projectElement) {
      console.log("Initializing project dropzone");
      initializeDropzone('form#dropzone_project', {
        url: '/photos',
        uploadMultiple: false,
        addRemoveLinks: true,
        maxFiles: 12,
        acceptedFiles: "image/jpeg,image/png,image/gif,video/mp4,video/avi,video/quicktime",
        paramName: "photo[file]",
        dictInvalidFileType: 'This form only accepts images.',
        previewsContainer: "#dropzone_project_previews",
        handleVideo: true,
        autoProcessQueue: true,
        additionalInit: function() {
          this.on('sending', function(file, xhr, formData) {
            var form = document.querySelector('form#dropzone_project');
            if (form) {
              var attachableId = form.querySelector('input[name="photo[attachable_id]"]');
              var attachableType = form.querySelector('input[name="photo[attachable_type]"]');
              if (attachableId && attachableId.value) formData.append('photo[attachable_id]', attachableId.value);
              if (attachableType && attachableType.value) formData.append('photo[attachable_type]', attachableType.value);
            }
          });
        }
      });
    }

    // Fast uploader is initialized from app/views/shared/js/_dropzone.html.erb (legacy Rails)

    // Project page: upload to selected album (dropdown sync + dropzone)
    const projectAlbumsForm = document.getElementById('dropzone_project_albums');
    const projectAlbumSelect = document.getElementById('project_album_upload_select');
    const projectUploadContainer = document.querySelector('.project-albums-upload');
    if (projectAlbumsForm && projectAlbumSelect) {
      function syncProjectAlbumId() {
        const hidden = projectAlbumsForm.querySelector('input[name="photo[album_id]"]');
        if (hidden) hidden.value = projectAlbumSelect.value;
      }
      projectAlbumSelect.addEventListener('change', syncProjectAlbumId);
      syncProjectAlbumId();
      initializeDropzone('form#dropzone_project_albums', {
        url: '/photos',
        uploadMultiple: true,
        addRemoveLinks: true,
        maxFiles: 24,
        acceptedFiles: 'image/*',
        paramName: "photo[file]",
        dictInvalidFileType: 'Only images are accepted.',
        additionalInit: function() {
          this.on('sending', function(file, xhr, formData) {
            syncProjectAlbumId();
            // Album: from select (always present)
            var albumId = projectAlbumSelect.value;
            if (albumId) formData.append('photo[album_id]', albumId);
            // Attachable: from form hidden inputs, or from container data attributes
            var attachableId = projectAlbumsForm.querySelector('input[name="photo[attachable_id]"]');
            var attachableType = projectAlbumsForm.querySelector('input[name="photo[attachable_type]"]');
            if (attachableId && attachableId.value) {
              formData.append('photo[attachable_id]', attachableId.value);
            } else if (projectUploadContainer) {
              var pid = projectUploadContainer.getAttribute('data-project-id');
              var ptype = projectUploadContainer.getAttribute('data-project-type');
              if (pid) formData.append('photo[attachable_id]', pid);
              if (ptype) formData.append('photo[attachable_type]', ptype);
            }
          });
        }
      });
    }
  }, 300);
}

// Export the module
window.dropzoneModule = {
  init: initDropzones,
  initializeDropzone: initializeDropzone,
  destroyExistingDropzone: destroyExistingDropzone
}; 